module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-09.a2af0d21.png";